import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '../App'

// Fonts are bundled, never fetched. Draft night runs on a LAN with no internet
// guarantee (see README "Draft night on a LAN"), so a CDN webfont would fall
// back to the system stack on exactly the night the board is on a TV. Latin
// subsets only, and only the weights the design actually uses.
import '@fontsource/barlow-condensed/latin-600.css'
import '@fontsource/barlow-condensed/latin-700.css'
import '@fontsource/ibm-plex-sans/latin-400.css'
import '@fontsource/ibm-plex-sans/latin-500.css'
import '@fontsource/ibm-plex-sans/latin-600.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import '@fontsource/ibm-plex-mono/latin-600.css'

import '../styles/application.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
